module.exports = __webpack_public_path__ + "img/emoji-wink.6049f301.png";